<template>
  <v-container fluid class="gl-map-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-map`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Mapping
          </v-tab>
          <v-tab-item
            :value="'tab-map'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Mapping</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMap($event, 'mapcode')"
                        v-bind:value="initvalue.mapcode"
                        placeholder="Map Code"
                        persistent-hint
                        single-line hint="Enter the map code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMap($event, 'mapname')"
                        v-bind:value="initvalue.mapname"
                        placeholder="Map Name"
                        persistent-hint
                        single-line hint="Enter the map name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['Map', 'Other Map']"
                        :value="initvalue.maptype"
                        outlined
                        dense
                        v-on:change="onChangeMap($event, 'maptype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the map type">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=classes
                        v-model="accountsubclass1"
                        outlined
                        dense
                        placeholder="Credit Subclass"
                        persistent-hint
                        single-line hint="Please choose the subclass">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(account=>account.accountsubclass==accountsubclass1).map(x => {
                          return {text: x.accountname, value: x._id};
                          })"
                        :value="initvalue.credit_accountid"
                        v-on:change="onChangeMap($event, 'credit_accountid')"
                        outlined
                        dense
                        placeholder="Credit Account"
                        persistent-hint
                        single-line hint="Please choose the credit account">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=classes
                        v-model="accountsubclass2"
                        outlined
                        dense
                        placeholder="Debit Subclass"
                        persistent-hint
                        single-line hint="Please choose the subclass">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                          return {text: x.accountname, value: x._id};
                          })"
                        :value="initvalue.debit_accountid"
                        v-on:change="onChangeMap($event, 'debit_accountid')"
                        outlined
                        dense
                        placeholder="Debit Account"
                        persistent-hint
                        single-line hint="Please choose the debit account">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/gl-map/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editGLMap()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      change_map: {},
      photo: {},
      initvalue: {},
      accountsubclass1: null,
      accountsubclass2: null,
      classes: ['Bank', 'Current Asset', 'Current Liability', 'Sales Income', 'Service Income', 'Cost of Goods Sold', 'Salary', 'Salary Items', 'Other Income', 'Other Expense'],
    }
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('GLMap', ['updateGLMapRequest','updateGLMapImageRequest','updateGLMapPinRequest','getGLMapsRequest']),
    async editGLMap() {
      this.change_map._id = this.initvalue._id;
      await this.updateGLMapRequest(this.change_map);
      router.push('/gl-map/list');
    },
    onChangeMap(value, field){
      this.change_map[field] = value;
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLMap', ['isReceiving']),
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'GLMapList' });
    if(this.accounts.length==0) await this.getAccountsRequest();
    let account1 = this.accounts.find(account=>account._id==this.initvalue.credit_accountid);
    let account2 = this.accounts.find(account=>account._id==this.initvalue.debit_accountid);
    if(account1!=null) this.accountsubclass1 = account1.accountsubclass;
    if(account2!=null) this.accountsubclass2 = account2.accountsubclass;
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
